// This file is autogenerated by injectVersion.js. Any changes will be
// overwritten on commit!
export var VERSION = "1.4.7";
//# sourceMappingURL=version.js.map